module.exports = __webpack_public_path__ + "img/top-b-back7.610bd8e9.png";